export default "__VITE_ASSET__Vc$vTvwl__"